import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const columns = [
  {
    h: 'Platform',
    items: [
      { label: 'What ESGine does', href: '/#what' },
      { label: 'ESG-as-Code', href: '/#code' },
      { label: 'Workflow', href: '/#workflow' },
      { label: 'Industries', href: '/#industries' },
    ],
  },
  {
    h: 'Frameworks',
    items: [
      { label: 'CSRD', href: '/#code' },
      { label: 'SEC Climate', href: '/#code' },
      { label: 'CARB SB253 / SB261', href: '/#code' },
      { label: 'ISSB · SFDR · UK FCA', href: '/#code' },
    ],
  },
  {
    h: 'Company',
    items: [
      { label: 'Why it matters', href: '/#why' },
      { label: 'Engagement', href: '/#engagement' },
      { label: 'Trust', href: '/#contact' },
      { label: 'Compliance', href: '/#contact' },
    ],
  },
  {
    h: 'Contact',
    items: [
      { label: 'Request access', href: '/#contact' },
      { label: 'Book a briefing', href: '/#contact' },
      { label: 'compliance@esgine.io', href: 'mailto:compliance@esgine.io', external: true },
      { label: 'LinkedIn', href: 'https://www.linkedin.com/company/esgineio/', external: true },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="relative bg-[#0B1F2D] text-[#FAFAF5] overflow-hidden">
      <div className="absolute inset-0 grain opacity-20" />
      <div className="relative max-w-[1320px] mx-auto px-6 lg:px-10">

        {/* Big wordmark */}
        <div className="pt-16 pb-10 border-b border-white/10">
          <div className="flex items-end justify-between flex-wrap gap-6">
            <div className="flex items-end gap-5">
              <img
                src="https://customer-assets.emergentagent.com/job_esgine-refresh/artifacts/x63zrzpq_apple-touch-icon.png"
                alt="ESGine"
                className="w-20 h-20 lg:w-28 lg:h-28 object-contain mb-3"
              />
              <div className="font-display text-[14vw] sm:text-[120px] lg:text-[180px] leading-[0.9] tracking-tight">
                ESGine<span className="text-[#7BC2B0] italic">.</span>
              </div>
            </div>
            <div className="text-[14px] text-[#FAFAF5]/70 max-w-[320px]">
              The world's only ESG-as-Code® compliance platform. Seven frameworks. 90+ rules. Every outcome maps to a clause.
            </div>
          </div>
        </div>

        {/* Columns */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 py-12 border-b border-white/10">
          {columns.map((col) => (
            <div key={col.h}>
              <div className="text-[11px] uppercase tracking-[0.14em] text-[#FAFAF5]/45">{col.h}</div>
              <ul className="mt-4 space-y-2.5">
                {col.items.map((item) => (
                  <li key={item.label}>
                    {item.external ? (
                      <a
                        href={item.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-[14px] text-[#FAFAF5]/85 hover:text-[#7BC2B0] transition-colors inline-flex items-center gap-1"
                      >
                        {item.label}
                        <ArrowUpRight className="w-3 h-3" />
                      </a>
                    ) : (
                      <Link
                        to={item.href}
                        className="text-[14px] text-[#FAFAF5]/85 hover:text-[#7BC2B0] transition-colors"
                      >
                        {item.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom */}
        <div className="py-7 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <div className="text-[12px] text-[#FAFAF5]/55">
            © {new Date().getFullYear()} ESGine® · ESG-as-Code® · All rights reserved.
          </div>
          <div className="flex items-center gap-5 text-[12px] text-[#FAFAF5]/55">
            <Link to="/privacy" className="hover:text-[#FAFAF5] transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-[#FAFAF5] transition-colors">Terms of Service</Link>
            <a href="https://x.com/TheESGine" target="_blank" rel="noopener noreferrer" className="hover:text-[#FAFAF5] transition-colors">@TheESGine</a>
            <a href="https://www.linkedin.com/company/esgineio/" target="_blank" rel="noopener noreferrer" className="hover:text-[#FAFAF5] transition-colors">LinkedIn</a>
          </div>
        </div>

      </div>
    </footer>
  );
}
